import { Provider } from "@rollbar/react"
import RollbarInit from "rollbar"

import { containsPrivateImageUrl } from "./rollbarPrivacy"

const rollbarConfig: RollbarInit.Configuration = {
  accessToken: import.meta.env.VITE_ROLLBAR_CLIENT_TOKEN || "xxx",
  captureUncaught: true,
  captureUnhandledRejections: true,
  scrubTelemetryInputs: true,
  filterTelemetry: (event) => containsPrivateImageUrl(event),
  // Also protect automatic exceptions containing a signed URL in their message.
  checkIgnore: (_isUncaught, args, item) =>
    containsPrivateImageUrl(args) || containsPrivateImageUrl(item),
  payload: {
    environment: import.meta.env.VITE_ENVIRONMENT,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: import.meta.env.VITE_GIT_SHA,
      },
    },
    server: {
      branch: import.meta.env.VITE_APP_BRANCH,
    },
  },
  enabled: import.meta.env.PROD,
}

// eslint-disable-next-line react-refresh/only-export-components
export const rollbar = new RollbarInit(rollbarConfig)

export default function RollbarProvider({ children }: { children: React.ReactNode }): JSX.Element {
  return <Provider instance={rollbar}>{children}</Provider>
}
